"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("./js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { viewBox: "0 0 1152 1152" },
      _react2.default.createElement("path", { fill: "#D4F10D", d: "M0 576c0 318.1 257.9 576 576 576s576-257.9 576-576S894.1 0 576 0 0 257.9 0 576zm59.4 0C59.4 290.3 290.7 58.8 576 58.8s516.6 231.6 516.6 517.2-231.3 517.2-516.6 517.2S59.4 861.7 59.4 576z" }),
      _react2.default.createElement("path", { fill: "#F8FFCB", d: "M575.7 670.3c-16.1 0-31.2-4.2-44.3-11.5v51c13.9 4.7 28.8 7.3 44.3 7.3 76.1 0 142.3-56.3 142.3-138.3V206.9c-15.2-5.8-31-12.6-46.9-16.4V579c-.1 56.7-45.2 91.3-95.4 91.3zm1.1-182.2c16.2 0 27.8 4.3 41 11.7v-51.1c-14-4.8-29-7.4-44.5-7.4-76.1 0-136.8 62.1-136.8 138.1v369.2c15.2 5.6 31.5 10.4 47.4 14.1V579c.1-50.1 42.7-90.9 92.9-90.9zm194.5 90.2c.7 124.2-90.7 194.4-195.6 194.4-15.2 0-30.1-3.2-44.3-6.6v19c14.3 3.1 29.1 4.7 44.3 4.7 116.2 0 213-83.8 212.3-210.7V240.9c-6.7-4.3-10-9-17-12.8l.3 350.2zM575.9 386c15.3-.1 28.2.3 41.9 4.5v-17.2c-14.4-3.1-29.3-4.8-44.5-4.8-116.2 0-206.4 87.3-206.4 203.4v341.8c6.7 4.2 9.6 7.9 16.6 11.6V579c.1-104.8 80-192.5 192.4-193zm264.9 192.8c2.2 155.4-112.1 263.1-265.1 263.1-15.1 0-29.9-2-44.3-4.5v19.1c14.4 2.3 29.2 3.5 44.3 3.5 154.9 0 283.6-107.1 282.1-280.9V297.6c-6.6-6.7-9.9-12.5-17-18.7v299.9zM297.4 857.9c6.6 6.5 9.4 13.1 16.4 19.2V576.9c.7-158.8 107.1-258.8 250.7-258.8 15.2 0 33.3 1.4 47.8 3.9v-20.1c-14.5-2.3-29.4-3.6-44.5-3.6C412.8 298.4 297 408.1 297 577l.4 280.9z" })
    )
  );
};

WrappedIcon.displayName = 'AdobeCampaignColorDark';
exports.default = WrappedIcon;

